const SEARCH_EXCLUSIONS = [
  ' -tag:custom',
  ' -tag:swatch',
  " -tag:'corporate gift'",
  ' -tag:spently_GC',
];

window.appendSearchExclusions = (query) => {
  let modifiedQuery = (query || '').trim();

  if (!modifiedQuery) {
    return modifiedQuery;
  }

  SEARCH_EXCLUSIONS.forEach((exclusion) => {
    const needle = exclusion.trim();

    if (!modifiedQuery.includes(needle)) {
      modifiedQuery += exclusion;
    }
  });

  return modifiedQuery;
};

window.stripSearchExclusions = (query) => {
  return (query || '').split(' -tag:')[0].trim();
};

const normalizeSearchText = (text) => (text || '').replace(/\s+/g, ' ').trim().toLowerCase();

window.isGiftCardsSuggestion = (text) => normalizeSearchText(text).includes('gift cards');

window.shouldHideSuggestion = (text) => {
  const normalized = normalizeSearchText(text);

  if (window.isGiftCardsSuggestion(normalized)) {
    return false;
  }

  return normalized.includes('gift');
};

window.shouldHideProduct = (text) => normalizeSearchText(text).includes('gift');

window.filterPredictiveSearchResults = (container) => {
  if (!container) {
    return;
  }

  container.querySelectorAll('#predictive-search-results-queries-list .predictive-search__list-item').forEach((item) => {
    const heading = item.querySelector('.predictive-search__item-heading');
    const text = heading?.textContent || item.textContent;

    if (window.shouldHideSuggestion(text)) {
      item.remove();
    }
  });

  container.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item').forEach((item) => {
    const heading = item.querySelector('.predictive-search__item-heading');
    const text = heading?.textContent || item.textContent;

    if (window.shouldHideProduct(text)) {
      item.remove();
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action="/search"]').forEach((form) => {
    if (form.dataset.searchExclusionsBound === 'true') {
      return;
    }

    form.dataset.searchExclusionsBound = 'true';

    form.addEventListener('submit', (event) => {
      const searchInput = form.querySelector('input[name="q"]');

      if (!searchInput || !searchInput.value.trim()) {
        return;
      }

      if (form.closest('predictive-search')) {
        return;
      }

      event.preventDefault();

      const modifiedQuery = window.appendSearchExclusions(searchInput.value);
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'q';
      hiddenInput.value = modifiedQuery;
      searchInput.name = '';
      form.appendChild(hiddenInput);
      form.submit();
    });
  });
});
